/*eslint-disable*/
import store from '@/store';
import router from '@/router';

let errorStatus = '';
let enableRedirect = false;

const redirectToHome = () => {
  const { productCode, productType, productTerm } = router.app.$route.params;
  const { refer } = router.app.$route.meta;

  if (productType) {
    router.push(`/${refer}/${productType}/${productCode}/${productTerm}`);
  } else {
    router.push(`/${refer}`);
  }
};

const redirectOnError = () => {
  const statusCodes = ['404', '400', '500'];

  switch (true) {
    case statusCodes.includes(errorStatus):
      if (statusCodes.includes(errorStatus) && enableRedirect) {
        if (
          new Date(Date.now()).getSeconds() >
          JSON.parse(localStorage.getItem('auth')).refreshExpiresIn
        ) {
          window.location = this.$appSettings.serverSettings.redirectUrl;
        } else {
          redirectToHome();
        }
      }
      break;

    case '500':
      // eslint-disable-next-line
      location.reload();
      break;

    case '405':
      // eslint-disable-next-line
      break;

    default:
      console.log('This error status code is not handled');
      break;
  }
};

const assembleMessage = (message, title) => {
  const messageArray = [];
  messageArray.push(message);

  store.dispatch('appStore/setAppData', {
    message: {
      content: message,
      type: 'error',
      component: 'modal',
      title,
      cancelCallback: redirectOnError,
      close: true,
      persistent: true,
    },
  });
};

const setExceptionError = (type = 'DEFAULT') => {
  assembleMessage(
    router.app.$t(`systemMessages.exceptions.${type}.message`),
    router.app.$t(`systemMessages.exceptions.${type}.title`)
  );
};

const handleError = (e, type = undefined, redirect = false, hideError = []) => {
  const { status, data } = e.response || e;

  store.dispatch('appStore/setAppData', {
    inProgress: false,
  });

  if (status && data) {
    const { title, detail, causes, error, message } = (data && typeof data.error === 'object') ? data.error : data;

    errorStatus = status.toString();
    enableRedirect = redirect;
    if (type) {
      if (hideError.length && Array.isArray(hideError)) {
        if (hideError.includes(errorStatus)) {
          return;
        }
      }
      setExceptionError(type);
      return;
    }
    // const errorMsgBody = `systemMessages.${status}.${(error) ? `custom.${error.replace(/[^a-z0-9,.]/gi, '')}` : 'message'}`;
    const errorMsgBody = causes
      ? causes.map((cause) => cause.field + ' ' + cause.message).join('\n')
      : (typeof error === 'string') ? error : (data?.detail) ? data.detail : 'Either Server or API is down. Please contact system administration.';
    const errorTitle = title || 'Error'
    if ((errorMsgBody !== undefined && !errorMsgBody.includes('LISA'))) {
      assembleMessage(message ? message : errorMsgBody, errorTitle, enableRedirect);
    }
  } else if (!status) {
    if (e.toString().indexOf('Network Error') !== -1) {
      assembleMessage(
        router.app.$t('systemMessages.exceptions.NETWORK_ERROR.message'),
        router.app.$t('systemMessages.exceptions.NETWORK_ERROR.title')
      );
    }
  }
};

export default handleError;
